import { Link } from "react-router-dom";
import { Linkedin, Mail } from "lucide-react";
import ContactDialog from "./ContactDialog";

const COLS = [
    {
        title: "Platform",
        links: [
            { l: "Services", to: "/services" },
            { l: "Industries", to: "/industries" },
            { l: "Pricing", to: "/pricing" },
            { l: "Track a container", to: "/track" },
            { l: "Book a demo", to: "/demo" },
            { l: "Get a quote", to: "/quote" },
        ],
    },
    {
        title: "Resources",
        links: [
            { l: "Insights", to: "/resources" },
            { l: "Early access", to: "/#early-access" },
            { l: "FAQ", to: "/#faq" },
            { l: "Contact", to: "/#contact" },
        ],
    },
    {
        title: "Company",
        links: [
            { l: "About", to: "/#about" },
            { l: "Privacy policy", to: "/privacy" },
            { l: "Terms & conditions", to: "/terms" },
        ],
    },
];

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="relative border-t border-white/10 bg-[#070709]">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <div className="grid lg:grid-cols-12 gap-10">
                    <div className="lg:col-span-4">
                        <div className="font-display text-2xl text-white tracking-tight">WE&nbsp;DELVR LOGISTICS</div>
                        <p className="text-zinc-400 mt-4 max-w-sm text-sm leading-relaxed">
                            Solutions for the unique logistics problems faced by Australian
                            importers and exporters. Before, during and after shipment.
                        </p>
                        <div className="mt-7 flex items-center gap-3">
                            <a
                                href="https://www.linkedin.com/company/wedelvr"
                                target="_blank"
                                rel="noreferrer"
                                data-testid="footer-linkedin"
                                aria-label="WE DELVR LOGISTICS on LinkedIn"
                                className="w-9 h-9 inline-flex items-center justify-center rounded-md border border-white/10 hover:border-cyan-400/50 hover:text-cyan-300 text-zinc-400 transition-colors"
                            >
                                <Linkedin size={16} />
                            </a>
                            <ContactDialog>
                                <button
                                    type="button"
                                    aria-label="Send us a message"
                                    data-testid="footer-email"
                                    className="w-9 h-9 inline-flex items-center justify-center rounded-md border border-white/10 hover:border-cyan-400/50 hover:text-cyan-300 text-zinc-400 transition-colors"
                                >
                                    <Mail size={16} />
                                </button>
                            </ContactDialog>
                        </div>
                    </div>

                    {COLS.map((col) => (
                        <div key={col.title} className="lg:col-span-2">
                            <div className="text-xs font-mono-accent text-zinc-500 uppercase tracking-[0.2em] mb-4">
                                {col.title}
                            </div>
                            <ul className="space-y-2 text-sm">
                                {col.links.map((link) => (
                                    <li key={link.to}>
                                        <Link
                                            to={link.to}
                                            data-testid={`footer-link-${link.l.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                                            className="text-zinc-400 hover:text-cyan-300 transition-colors"
                                        >
                                            {link.l}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}

                    <div className="lg:col-span-2">
                        <div className="text-xs font-mono-accent text-zinc-500 uppercase tracking-[0.2em] mb-4">
                            Company info
                        </div>
                        <p className="text-sm text-zinc-400 leading-relaxed">
                            WE DELVR LOGISTICS PTY LTD <br />
                            Australia
                        </p>
                    </div>
                </div>

                <div className="mt-14 pt-6 border-t border-white/5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                    <p className="text-xs font-mono-accent text-zinc-500">
                        © {new Date().getFullYear()} WE DELVR LOGISTICS PTY LTD · ALL RIGHTS RESERVED
                    </p>
                    <p className="text-xs font-mono-accent text-zinc-500">
                        DELIVERING CONTROL ACROSS YOUR SUPPLY CHAIN
                    </p>
                </div>
            </div>
        </footer>
    );
}
